import * as React from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { CommonDatePickerProps } from '../types/common.types';

const CommonDatePicker: React.FC<CommonDatePickerProps> = ({
  name,
  label,
  value,
  onChange,
  disabled = false,
  required = false,
  error = false,
  helperText,
  fullWidth = true,
  maxDate,
}) => {
  const pickerValue: Dayjs | null = value ? dayjs(value) : null;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        value={pickerValue && pickerValue.isValid() ? pickerValue : null}
        onChange={(newValue: Dayjs | null) => onChange(newValue && newValue.isValid() ? newValue.format('YYYY-MM-DD') : '')}
        disabled={disabled}
        maxDate={maxDate ? dayjs(maxDate) : undefined}
        slotProps={{
          textField: {
            name,
            required,
            error,
            helperText,
            fullWidth,
            size: 'small',
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default CommonDatePicker;